
// import React, { useState } from "react";


// export default function WarehouseCalculator() {
//   const [industry, setIndustry] = useState("");
//   const [beneficiary, setBeneficiary] = useState("");
//   const [gender, setGender] = useState("");
//   const [cost, setCost] = useState("");
//   const [result, setResult] = useState(null);

//   // ✅ Rate based ONLY on Gender
//   const getRate = () => {
//     return gender === "female" ? 0.3333 : 0.25;
//   };

//   // ✅ Max based ONLY on Gender
//   const getMax = () => {
//     return gender === "female" ? 10000000 : 7500000;
//   };

//   const calculate = () => {
//     const numericCost = Number(cost); // ✅ important fix

//     if (!numericCost || numericCost <= 0) {
//       alert("Please enter a valid project cost");
//       return;
//     }

//     const rate = getRate();
//     const calc = numericCost * rate;
//     const max = getMax();

//     setResult({
//       rate: rate * 100,
//       calc,
//       max,
//       final: Math.min(calc, max),
//     });
//   };

  

//  const handleReset = () => {
//   setIndustry("");
//   setBeneficiary("");
//   setGender("");
//   setCost("");
//   setResult(null);
// };

//   return (
//     <div className="card">
//       <h2>Warehouse / Godown</h2>

//       {/* Industry Type */}
//       <label>Industry Type</label>
//       <select value={industry} onChange={(e) => setIndustry(e.target.value)}>
//         <option value="">Select Item</option>
//         <option value="godown">Godown</option>
//         <option value="warehouse">Warehouse</option>
//       </select>

//       {/* Beneficiary */}
//       <label>Beneficiary Type</label>
//       <select value={industry} onChange={(e) => setIndustry(e.target.value)}>
//         <option value="">Select Item</option>
//         <option value="proprietorship">Proprietorship</option>
//         <option value="partnership">Partnership</option>
//         <option value="private">Private Limited</option>
//       </select>

//       <small style={{ color: "#666" }}>
//         (Beneficiary type does not affect subsidy calculation)
//       </small>

//       {/* Gender */}
//       <label>Gender</label>
//       <select value={gender} onChange={(e) => setGender(e.target.value)}>
//         <option value="">Select Gender</option>
//         <option value="male">Male</option>
//         <option value="female">Female</option>
//       </select>

//       <small style={{ color: "#666" }}>
//         (In case one partner is male, please select male)
//       </small>

//       {/* Cost */}
//       <label>Project Cost (₹)</label>
//       <input
//         type="number"
//         value={cost}
//         onChange={(e) => setCost(e.target.value)}
//         placeholder="Enter amount"
//       />

//       {/* Buttons */}
//       <div className="btn-group">
//         <button onClick={calculate} disabled={!cost}>
//           Calculate Subsidy
//         </button>
//         <button className="reset-btn" onClick={handleReset}>
//           Reset
//         </button>
//       </div>

//       {/* Result */}
//       {result && (
//         <div className="result">
//           <p>
//             Applied Rule:{" "}
//             {gender === "female"
//               ? "33.33% (Women / SC-ST) - Max ₹1 Cr"
//               : "25% (General) - Max ₹75 Lakhs"}
//           </p>
//           <p>Subsidy Rate: {result.rate.toFixed(2)}%</p>
//           <p>Calculated Amount: ₹{result.calc.toLocaleString()}</p>
//           <p>Maximum Eligible: ₹{result.max.toLocaleString()}</p>
//           <h3>Final Subsidy: ₹{result.final.toLocaleString()}</h3>
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useState } from "react";

export default function WarehouseCalculator() {
  const [industry, setIndustry] = useState("");
  const [beneficiary, setBeneficiary] = useState("");
  const [gender, setGender] = useState("");

  const [inputType, setInputType] = useState("sft"); // 👈 NEW

  const [sft, setSft] = useState("");
  const [cost, setCost] = useState("");

  const [result, setResult] = useState(null);

  const COST_PER_SFT = 1000;

  // const getRate = () => {
  //   return gender === "female" ? 0.3333 : 0.25;
  // };

  const getRate = () => {
  return gender === "female" || gender === "scst"
    ? 0.3333
    : 0.25;
};

  // const getMax = () => {
  //   return gender === "female" ? 10000000 : 7500000;
  // };

  const getMax = () => {
  return gender === "female" || gender === "scst"
    ? 10000000   
    : 7500000;   
};

  const calculate = () => {
    if (!industry || !beneficiary || !gender) {
      alert("Please select all dropdowns");
      return;
    }

    let projectCost = 0;

    // ✅ Choose input type
    if (inputType === "sft") {
      const area = Number(sft);
      if (!area) {
        alert("Enter valid square feet");
        return;
      }
      projectCost = area * COST_PER_SFT;
    } else {
      const manualCost = Number(cost);
      if (!manualCost) {
        alert("Enter valid project cost");
        return;
      }
      projectCost = manualCost;
    }

    const rate = getRate();
    const calc = projectCost * rate;
    const max = getMax();

    setResult({
      projectCost,
      rate: rate * 100,
      calc,
      max,
      final: Math.min(calc, max),
    });
  };

  const handleReset = () => {
    setIndustry("");
    setBeneficiary("");
    setGender("");
    setSft("");
    setCost("");
    setResult(null);
    setInputType("sft");
  };

  return (
    <div className="card-calculator">
      <h2>Warehouse / Godown</h2>

      {/* Industry */}
      <label>Industry Type</label>
      <select value={industry} onChange={(e) => setIndustry(e.target.value)}>
        <option value="">Select Industry</option>
        <option value="godown">Godown / Warehouse</option>
        {/* <option value="warehouse">Warehouse</option> */}
      </select>

      {/* Beneficiary */}
      <label>Beneficiary Type</label>
      <select value={beneficiary} onChange={(e) => setBeneficiary(e.target.value)}>
        <option value="">Select Beneficiary</option>
        <option value="proprietorship">Proprietorship</option>
        <option value="partnership">Partnership</option>
        <option value="private">Private Limited</option>
      </select>

      {/* Gender */}
      <label>Gender</label>
      <select value={gender} onChange={(e) => setGender(e.target.value)}>
        <option value="">Select Gender</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
         <option value="scst">SC / ST</option>
      </select>

      <small style={{ color: "#666" }}>
  (In case one partner is male, please select male)
</small>

      {/* 🔥 Input Type Toggle */}
      <label>Input Type</label>
      <select value={inputType} onChange={(e) => setInputType(e.target.value)}>
        <option value="sft">Based on Square Feet</option>
        <option value="cost">Enter Project Cost</option>
      </select>

      {/* 👇 Conditional Inputs */}
      {inputType === "sft" ? (
        <>
          <label>Area (Square Feet)</label>
          <input
            type="number"
            value={sft}
            onChange={(e) => setSft(e.target.value)}
            placeholder="Enter SFT"
          />

          {sft && (
            <p>
              Estimated Cost: ₹{(sft * COST_PER_SFT).toLocaleString()}
            </p>
          )}
        </>
      ) : (
        <>
          <label>Project Cost (₹)</label>
          <input
            type="number"
            value={cost}
            onChange={(e) => setCost(e.target.value)}
            placeholder="Enter amount"
          />
        </>
      )}

      {/* Buttons */}
      <div className="btn-group">
        <button onClick={calculate}>Calculate Subsidy</button>
        <button className="reset-btn" onClick={handleReset}>
          Reset
        </button>
      </div>

      {/* Result */}
      {result && (
        <div className="result">

          <p>
  Applied Rule:{" "}
  {gender === "female" || gender === "scst"
    ? "33.33% (Women / SC-ST) - Max ₹1 Cr"
    : "25% (General) - Max ₹75 Lakhs"}
</p>
          <p>Project Cost: ₹{result.projectCost.toLocaleString()}</p>
          <p>Subsidy Rate: {result.rate}%</p>
          <p>Calculated: ₹{result.calc.toLocaleString()}</p>
          <p>Max Eligible: ₹{result.max.toLocaleString()}</p>
          <h3>Final Subsidy: ₹{result.final.toLocaleString()}</h3>
        </div>
      )}
    </div>
  );
}